import HttpService from "../util/HttpService";

const CONTEXT_PATH = "/cwm-notification/api/v2";
class NotificationService {
    updateFirebaseToken = (username: string, deviceToken: string) => {
        return HttpService.post(CONTEXT_PATH.concat('/notification-service/update-gcp-notification-user-detail'), {
            username: username,
            deviceToken: deviceToken,
            deviceType:"WEB"
        });
    }

    revokeFirebaseToken = (username: string) => {
        return HttpService.put(CONTEXT_PATH.concat('/notification-service/revoke-gcp-notification-user-detail'), {
            username: username,
            deviceToken: "",
            deviceType:"WEB"
        });
    }


}

const notificationService = new NotificationService();
export default notificationService;
